import Svg from './Svg';
import type { SvgProps } from './Svg';

const CloseIcon = (props: SvgProps) => (
  <Svg width={16} height={17} {...props}>
    <path
      className="stroke-current"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="1.5"
      d="M12.8 13.3 3.2 3.7M12.8 3.7l-9.6 9.6"
    />
  </Svg>
);

export default CloseIcon;
